/* eslint-disable no-console */
import { Box, Button, SelectChangeEvent, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import colors from '../../constants/colors'
import reportsService from '../../services/reportsService'
import { AppDispatch } from '../../store'
import authSelectors from '../../store/auth/authSelectors'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { deselectCase } from '../../store/reports/reportsSlice'
import CardTAG from '../CardTAG'
import FormLayout from '../forms/FormLayout'
import ModalTAG from '../ModalTAG'
import PageBodyLayout from '../PageBodyLayout'
import ReportSubheader from '../ReportSubheader'
import CaseResolveDataPart from './DataPart'
import { DISPOSITION_TYPE } from '../../store/reports/types'

import { success } from '../../utils/alertUtils';

const ResolveCase: React.FC = () => {
  const [openModalAreYouSure, setOpenModalAreYouSure] = useState(false)
  const [selectedDisposition, setSelectedDisposition] = useState<DISPOSITION_TYPE | any>('')
  const [description, setDescription] = useState<string | undefined>('')
  const [initialDescription, setInitialDescription] = useState<string | undefined>('')
  const [dispositionData, setDispositionData] = useState<{ value: string; text: string }[]>([])
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([])
  const [outcomesData, setOutcomesData] = useState<
    { value: string; text: string; checked: boolean; id: string }[]
  >([])

  const selectedReport = useSelector(reportsSelectors.selectedReport)
  const userEditAccess = useSelector(authSelectors.userReportEditAccess)

  const dispatch = useDispatch<AppDispatch>()

  const handleResolveCaseButton = () => {
    setOpenModalAreYouSure(true)
  }

  const cancelLogic = () => {
    setOpenModalAreYouSure(false)
  }

  const resolveCaseLogic = async () => {
    const formData = new FormData()
    if (selectedDisposition) formData.append('disposition', selectedDisposition)
    if (selectedReport?.id) formData.append('report', selectedReport.id as unknown as string)
    if (description) formData.append('description', description)
    if (uploadedFiles) 
      uploadedFiles.forEach((file) => formData.append('file', file))
    if (outcomesData)
      outcomesData
        .filter(outcome => outcome.checked)
        .forEach(checkedOutcome => {
          formData.append('outcomes', checkedOutcome?.id)
        })

    await reportsService.postResolvedReport(formData)
    dispatch(deselectCase({ value: undefined }))
    success('Case Resolved');
    setOpenModalAreYouSure(false)
  }

  const dispositionHandler = (e: SelectChangeEvent) => {
    setSelectedDisposition(e.target.value)
  }

  const outcomesChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const data = outcomesData.map(outcome => {
      return outcome.value === event.target.value
        ? {
            ...outcome,
            checked: event.target.checked,
          }
        : outcome
    })

    setOutcomesData(data)
  }

  useEffect(() => {
    const fetchData = async () => {
      const { data: dispositionResponse } = await reportsService.getAllDispositions()
      const { data: allOutcomesResponse } = await reportsService.getAllOutcomes()
     
      setDispositionData(dispositionResponse)

      // console.log('allOutcomesResponse' , allOutcomesResponse); 

       setOutcomesData(
          allOutcomesResponse.map((outcome: { id: any; label: string; text: string }) => {
            return { 
              id: outcome?.id,
              text: outcome?.label,
              value: outcome?.text,
              checked: selectedReport?.resolvedData ? selectedReport?.resolvedData?.outcomes?.findIndex((item) => item.text === outcome?.text) === -1 ? false : true : false,
             }
          }),
        )
    }

    fetchData();
  }, []);


  useEffect(() => {
    if (selectedReport) {
      if (selectedReport.resolvedData) {
        const { description, file, disposition } = selectedReport.resolvedData
        // console.log('selectedReport.resolvedData', selectedReport.resolvedData)
        if (file) setUploadedFiles([file])
        if (description) setInitialDescription(description)
        if (disposition) setSelectedDisposition(disposition)
      }
    }
  }, [])
  return (
    <PageBodyLayout
      caseSubheader={<ReportSubheader />}
      filterPart={
        <>
          <CardTAG title='Resolve Case'>
            <FormLayout>
              <Typography variant='bodyRegular'>
                To resolve and archive this case please provide an explanation and upload any documents to support the case disposition, like a final report, written warning, notice of termination, etc. Archived cases will no longer be editable.
              </Typography>
              <Button
                variant='submitFormButton'
                onClick={handleResolveCaseButton}
                // disabled={selectedDisposition.length == 0 || !userEditAccess}
                disabled={(!description && uploadedFiles.length == 0) || !userEditAccess}
              >
                <Typography variant='bodyBold'>Resolve this case and move it to Archive</Typography>
              </Button>
            </FormLayout>
          </CardTAG>
          <ModalTAG open={openModalAreYouSure} style={{ width: 'auto' }}>
            <CardTAG title='Resolve Case' boxError={true} closable={true} closeCard={cancelLogic}>
              <Typography variant='bodyBold' color={colors.TAG_RED}>
                Are you sure you want to resolve this case?
              </Typography>
              <Typography variant='bodyBold'>
                This will remove it from active investigation for all users and move it to the
                archive.
              </Typography>
              <Box sx={{ display: 'flex', gap: '3rem', width: '100%', paddingTop: '3rem' }}>
                <Button
                  onClick={resolveCaseLogic}
                  variant='submitFormButton'
                  sx={{ backgroundColor: colors.GREEN, color: colors.WHITE, flex: '50%' }}
                >
                  <Typography variant='bodyBold'>Resolve</Typography>
                </Button>
                <Button onClick={cancelLogic} variant='outlined' sx={{ flex: '50%' }}>
                  <Typography variant='bodyRegular' sx={{ whiteSpace: 'nowrap' }}>
                    Cancel
                  </Typography>
                </Button>
              </Box>
            </CardTAG>
          </ModalTAG>
        </>
      }
      dataPart={
        <CaseResolveDataPart
          dispositionData={dispositionData}
          outcomesData={outcomesData}
          setDescription={setDescription}
          description={initialDescription}
          dispositionHandler={dispositionHandler}
          selectedDisposition={selectedDisposition}
          outcomesChangeHandler={outcomesChangeHandler}
          setUploadedFiles={setUploadedFiles}
          uploadedFiles={uploadedFiles}
        />
      }
    />
  )
}

export default ResolveCase
